import { Component, Inject, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { ToastService } from 'app/common/toast-alert/toast.service';
import { GlobalsService } from 'app/globals-services/globals.service';
import { MultiTierHierarchyService } from '../services/multi-tier-hierarchy.service';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-policy-data',
  templateUrl: './policy-data.component.html',
  styleUrls: ['./policy-data.component.scss']
})
export class PolicyDataComponent implements OnInit {

  alertMsgs = {}

  isBrandLoggedIn:boolean=false;

  // Organization Policy Parameters
  orgDataViewMode = 'pri';  // public or private
  orgChemicalViewMode= 'F'; // full or high level  (F or H)
  orgWaterViewMode= 'F'; // full or high level
  orgEnergyViewMode= 'F'; // full or high level
  orgFacilityViewMode= 'F'; // full or high level
  
  // Suplier Policy Parameter
  suplierDataViewMode = 'pri';  // public or private
  suplierChemicalViewMode= 'F'; // full or high level
  suplierWaterViewMode= 'F'; // full or high level
  suplierEnergyViewMode= 'F'; // full or high level
  suplierFacilityViewMode= 'F'; // full or high level

  // Relationship Data Parameter/Variable
  selectedScope; 
  keySupplierViewMode='false';
  department;
  businessVolume;
  supplierType;
  vendorPartner;
  otherDetails;

  currentOrgPolicyData: any;   // stored current or modified



  /****************************************************************************************************************
   * 
   *   Contructor, Life Cycle Methods
   * 
   ****************************************************************************************************************/

  constructor(
    public dialogRef: MatDialogRef<PolicyDataComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private globalServices: GlobalsService,
    private toastService: ToastService,
    private translateService: TranslateService,
    private multiTierHierarchyService: MultiTierHierarchyService
  ) { }

  ngOnInit(): void {

    // this.fetchTranslations();
    // this.translateService.onLangChange.subscribe(() => {
    //   this.fetchTranslations();
    // });

    this.isBrandLoggedIn=this.globalServices.profile['organization_type'] !==1;

    this.getPolicyData();

  }


  /****************************************************************************************************************
   * 
   *   Private, Public Methods
   * 
   ****************************************************************************************************************/

  /**
   *   Fetching Language Translation File
   */

  // fetchTranslations() {
  //   this.translateService
  //     .get('BRAND_FACTORY_CONNECTION_COMPONENT.MESSAGES')
  //     .subscribe((response) => {
  //       this.alertMsgs = response;
  //     });
  // }



  /**
   *   Reset current modified policy data and restored previous or default policy data
   */
  resetModifiedPolicyData(){

    // if current user policy data is not empty then previous current data restore, else default value set
    if(this.currentOrgPolicyData && Object.keys(this.currentOrgPolicyData).length !== 0){
      
      this.orgDataViewMode = this.currentOrgPolicyData.own.View;  // public or private
      this.orgChemicalViewMode= this.currentOrgPolicyData.own.chemical.perfView; // full or high level
      this.orgWaterViewMode= this.currentOrgPolicyData.own.water.perfView; // full or high level
      this.orgEnergyViewMode= this.currentOrgPolicyData.own.energy.perfView; // full or high level
      this.orgFacilityViewMode= this.currentOrgPolicyData.own.facility.perfView; // full or high level
      
      // Suplier Policy Parameter
      this.suplierDataViewMode = this.currentOrgPolicyData.suppliers['view'];  // public or private
      this.suplierChemicalViewMode= this.currentOrgPolicyData.suppliers.chemical.perfView; // full or high level
      this.suplierWaterViewMode= this.currentOrgPolicyData.suppliers.water.perfView; // full or high level
      this.suplierEnergyViewMode= this.currentOrgPolicyData.suppliers.energy.perfView; // full or high level
      this.suplierFacilityViewMode= this.currentOrgPolicyData.suppliers.facility.perfView; // full or high level


    }else{

      this.orgDataViewMode = 'pri';  // public or private
      this.orgChemicalViewMode= 'F'; // full or high level
      this.orgWaterViewMode= 'F'; // full or high level
      this.orgEnergyViewMode= 'F'; // full or high level
      this.orgFacilityViewMode= 'F'; // full or high level
      
      // Suplier Policy Parameter
      this.suplierDataViewMode = 'pri';  // public or private
      this.suplierChemicalViewMode= 'F'; // full or high level
      this.suplierWaterViewMode= 'F'; // full or high level
      this.suplierEnergyViewMode= 'F'; // full or high level
      this.suplierFacilityViewMode= 'F'; // full or high level

    }


  }


  /**
   *   Save Or Update policy data.
   */
  saveOrUpdatePolicyData() {

    let payload = {

      "brandId":this.data.brandId,
      "supplierId": this.data.supplierId,
      "policyData": {

        "own": {
          "View": this.orgDataViewMode,
          "chemical": {
            "perfView": this.orgChemicalViewMode
          },
          "water": {
            "perfView": this.orgWaterViewMode
          },
          "energy": {
            "perfView": this.orgEnergyViewMode
          },
          "facility": {
            "perfView": this.orgFacilityViewMode
          }
        },
        "suppliers": {
          "view": this.suplierDataViewMode,
          "chemical": {
            "perfView": this.suplierChemicalViewMode
          },
          "water": {
            "perfView": this.suplierWaterViewMode
          },
          "energy": {
            "perfView": this.suplierEnergyViewMode
          },
          "facility": {
            "perfView": this.suplierFacilityViewMode
          }
        },
        "relationShipDetails":{
            "scope": this.selectedScope,
            "keySupplier": this.keySupplierViewMode,
            "department": this.department,
            "businessVolume": this.businessVolume,
            "supplierType": this.supplierType,
            "vendorPartnerId": this.vendorPartner,
            "otherDetails": this.otherDetails
        }

      }

    }

    this.globalServices.showSpinner();
    this.multiTierHierarchyService.saveOrUpdatePolicyData(payload).subscribe(
      (response: any) => {
        this.globalServices.hideSpinner();
        this.toastService.success("Policy data successfully saved.");

      }, (err) => {
        this.globalServices.hideSpinner();
        this.toastService.error("Something went wrong. Please try again !");
      });

  }

  /**
   *  Fetch Policy Data By Organization Id
   */
  getPolicyData(){

    this.globalServices.showSpinner();
    this.multiTierHierarchyService.getOrgPolicyData(this.data.brandId, this.data.supplierId).subscribe(
      (response: any) => {
        this.globalServices.hideSpinner();
        this.currentOrgPolicyData=response.policyData;

        this.setPolicyDataToFields();

      }, (err) => {
        this.globalServices.hideSpinner();
      });

  }

  setPolicyDataToFields(){

    if(this.currentOrgPolicyData){

      // My Data Parameter
      this.orgDataViewMode = this.currentOrgPolicyData.own.View;  // public or private
      this.orgChemicalViewMode= this.currentOrgPolicyData.own.chemical.perfView; // full or high level
      this.orgWaterViewMode= this.currentOrgPolicyData.own.water.perfView; // full or high level
      this.orgEnergyViewMode= this.currentOrgPolicyData.own.energy.perfView; // full or high level
      this.orgFacilityViewMode= this.currentOrgPolicyData.own.facility.perfView; // full or high level
      
      // Suplier Policy Parameter
      this.suplierDataViewMode = this.currentOrgPolicyData.suppliers['view'];  // public or private
      this.suplierChemicalViewMode= this.currentOrgPolicyData.suppliers.chemical.perfView; // full or high level
      this.suplierWaterViewMode= this.currentOrgPolicyData.suppliers.water.perfView; // full or high level
      this.suplierEnergyViewMode= this.currentOrgPolicyData.suppliers.energy.perfView; // full or high level
      this.suplierFacilityViewMode= this.currentOrgPolicyData.suppliers.facility.perfView; // full or high level

      // RelationShip Parameter
      this.selectedScope = this.currentOrgPolicyData?.relationShipDetails?.scope;
      this.keySupplierViewMode = this.currentOrgPolicyData?.relationShipDetails?.keySupplier;
      this.department = this.currentOrgPolicyData?.relationShipDetails?.department;
      this.supplierType = this.currentOrgPolicyData?.relationShipDetails?.supplierType;
      this.businessVolume = this.currentOrgPolicyData?.relationShipDetails?.businessVolume;
      this.vendorPartner = this.currentOrgPolicyData?.relationShipDetails?.vendorPartnerId;
      this.otherDetails = this.currentOrgPolicyData?.relationShipDetails?.otherDetails;

    }


  }

  close(){
    this.dialogRef.close();
  }



}
